module.exports = __webpack_public_path__ + "static/img/12areaB_14.b269a03.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_14.png
// module id = 1106
// module chunks = 1